import Yt from "./trigger-condition.js";
export default class Zt {
  constructor(t, i) {
    (this.fu = t), (this.du = i);
  }
  Jl(t) {
    if (null == this.fu) return !1;
    const i = Yt.gu(t[0], this.fu);
    if (!i) return !1;
    let r = null == this.du || 0 === this.du.length;
    if (null != this.du)
      for (let i = 0; i < this.du.length; i++)
        if (this.du[i] === t[1]) {
          r = !0;
          break;
        }
    return i && r;
  }
  static fromJson(t) {
    return new Zt(t ? t.id : null, t ? t.buttons : null);
  }
  ss() {
    return this.fu;
  }
}
